import { Space, Spin } from "antd";
import React, { useEffect, useState } from "react";
import ContentHead from "../../components/Admin/Common/ContentHead";
import CustomeHeader from "../../components/Admin/Common/CustomeHeader";
import ViewButton from "../../components/Admin/Common/ViewButton";
import {
  ItemMenu,
  TablePagination,
  TableTab,
} from "../../StyledComponents/Common";
import {
  TableTitle,
  TableTop,
} from "../../StyledComponents/CreateKeyAccountManager";
import { MainContainer } from "../../StyledComponents/Dashboard";
import { DeleteOutlined } from '@ant-design/icons';
// import { IconImg } from '../StyledComponents/Header'
import {
  ContentContainer,
  TableFilter,
} from "../../StyledComponents/RateManagement";
import { Divider, Modal } from "antd";
import RateUploadModal from "../../components/Admin/RateManagement/RateUploadModal";
import DropDownButton1 from "../../components/Admin/Common/DropDownButton1";
import {
  get_rate_list,
  get_surcharge_rate_list,
  get_transport_rate_list,
  get_vas_rate_list,
} from "../../store/Admin/RateManagement/RateManagementSlice";
import { useDispatch, useSelector } from "react-redux";
import { ExclamationCircleFilled } from "@ant-design/icons";
// import { shortenString } from '../../functions/Utils'
import { FilterSection, SpinContainer } from "../../StyledComponents/Queries";
import TransportationTable from "../../components/Admin/Common/TransportationTable";
import VehicleDetailPage from "../../components/Admin/VehicleManageMent/VehicleDetailPage";
import { get_vehicle_types ,delete_vehicle} from "../../store/Admin/VehicleManagement/VehicleManagement";
import AddButton from "../../components/Admin/Common/AddButton";
import SearchBox from "../../components/Admin/Common/SearchBox";
import { authuser } from "../../store/Authentication/AuthSlice";
let debounceTimer = null;
function VehicleRateManagement() {
  const dispatch = useDispatch();
  const loginedUser = useSelector(authuser);
  const userroles = loginedUser?.userroles;
  // const userroles = "air_admin"
  const [tabType, setTabType] = useState(
    userroles === "ocean_admin" ? "ocean" : "air"
  );
  const [pageType, setPageType] = useState("table");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [instance, setInstance] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [rateType, setRateType] = useState("");
  const [type, setType] = useState("view");
  const [data, setData] = useState([]);
  const [call_list, setCallList] = useState(true);
  const [loading, setLoading] = useState(true);

  const { confirm } = Modal;

  useEffect(() => {
    if (call_list) {
      dispatch(get_vehicle_types(''))
        .then((res) => {
          // console.log('login res => ',res);
          if (res?.payload?.status === 200) {
            setData(res?.payload?.data?.data);
            setCallList(false);
            setLoading(false);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
    // setIsEdit(false)
  }, [call_list]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (current, size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const handleView = (record) => {
    setInstance(record);
    setPageType("view_page");
    setType("view");
  };

  const handleAdd = (key) => {
      setInstance({});
      setPageType("view_page");
      setType("create");
  };

  const handleBack = () => {
    if (type === "edit") {
      confirm({
        title: "Do you want to exit?",
        icon: <ExclamationCircleFilled />,
        content: "Your changes will not be saved.",
        okButtonProps: {
          style: {
            backgroundColor: "#1890ff",
            borderColor: "#1890ff",
            borderRadius: "4px",
            color: "#fff",
          },
        },
        onOk() {
          setCallList(true);
          setPageType("table");
          setInstance({});
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    } else {
      // setCallList(true)
      setPageType("table");
      setInstance({});
    }
  };

  const handleDeleteRecord = async (item)=>{
    console.log(item,'item')
    dispatch(delete_vehicle(item?._id)).then((res)=>{
      setData((prev)=>{
        return prev?.filter((data)=>data?._id!=item?._id)
      })

    }).catch(err=>{

    })
  }

  const columns = [
    {
      title: "Country",
      dataIndex: "country",
      render: (text, record, index) => {
        return text ? text?.join('  ,  ') : "-";
      },
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Fuel Type",
      dataIndex: "fuel",
    },
    {
      title: "Length (m)",
      dataIndex: "length",
    },
    {
      title: "Breadth (m)",
      dataIndex: "breadth",
    },
    {
      title: "Height (m)",
      dataIndex: "height",
    },
    {
      title: "CBM Max",
      dataIndex: "cbmMax",
    },
    {
      title: "Weight Max (kg)",
      dataIndex: "weightMax",
    },
    {
      title: "KM Range",
      dataIndex: "kmRange",
    },
    {
      title: "Action",
      dataIndex: "action",
      className: "text-right",
      render: (text, record, index) => {
        // if (index === 0) {
        //   return ''
        // }
       return (
        <Space>
        <ViewButton handleClick={() => handleView(record)} data={record} />
        <div className="icon_delete">
          <DeleteOutlined onClick={() => handleDeleteRecord(record)} style={{ cursor: 'pointer' }} />
        </div>
    </Space>
      );
      },
    },
  ];

  const items = [
    {
      label: <ItemMenu>Upload File</ItemMenu>,
      key: tabType,
    },
    {
      label: <ItemMenu>Individual Rate</ItemMenu>,
      key: "individual_rate",
    },
  ];
  const onSearch = (value) => {
    let queryStringObj = {};
    if (value?.length > 0) {
      queryStringObj["search"] = value;
    }
    let queryString = new URLSearchParams(queryStringObj).toString();
    queryString = queryString ? `?${queryString}` : "";
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      dispatch(get_vehicle_types(queryString))
      .then((res) => {
        // console.log('login res => ',res);
        if (res?.payload?.status === 200) {
          setData(res?.payload?.data?.data);
          setCallList(false);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error(err);
      });
    }, 700);
  };
  return (
    <section className="vehicleTypeMain">
      <MainContainer>
        <CustomeHeader title="Vehicle Type" description="Manage vehicle" />
        {pageType === "table" ? (
          <>
            <div className="mt-4 tableResponsiveASAP">
              <ContentContainer>
                <TableTop>
                  <TableTitle>View Vehicle</TableTitle>
                    <FilterSection className='filter'>
                  <SearchBox
                      onSearch={onSearch}
                    />
                  <AddButton title="Add Vehicle" handleClick={handleAdd} />
                  </FilterSection>
                  {/* <DropDownButton1 label="Add Vehicle" items={items} handleDropDownChange={handleAdd} />
                  <RateUploadModal
                    modalOpen={modalOpen}
                    setModalOpen={setModalOpen}
                    rateType={rateType}
                    setCallList={setCallList}
                    tabType="transportation"
                  /> */}
                </TableTop>

                {loading ? (
                  <SpinContainer className="user-quote">
                    <Spin />
                  </SpinContainer>
                ) : (
                  <TransportationTable
                    name="rate_management"
                    currentPage={currentPage}
                    pageSize={pageSize}
                    columns={columns}
                    data={data}
                    rowKey="_id"
                    setCallList={setCallList}
                    scroll={true}
                    showScroll={true}
                  />
                )}
              </ContentContainer>
              <div className="paginationCustom">
                <TablePagination
                  style={{ marginTop: 16, textAlign: "center" }}
                  onChange={handlePageChange}
                  onShowSizeChange={handlePageSizeChange}
                  defaultCurrent={currentPage}
                  defaultPageSize={10}
                  total={data?.length ? data?.length : 10}
                  showSizeChanger={false}
                  showQuickJumper={false}
                />
              </div>
            </div>
          </>
        ) : pageType === "view_page" ? (
          <ContentContainer>
            <ContentHead
              title="Details"
              handleClick={() => handleBack()}
              border={false}
            />
            <VehicleDetailPage
              type={type}
              instance={instance}
              setPageType={setPageType}
              setType={setType}
              setCallList={setCallList}
              tabType={tabType}
              setTabType={setTabType}
            />
          </ContentContainer>
        ) : null}
      </MainContainer>
    </section>
  );
}

export default VehicleRateManagement;
